import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c4a36a5e&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=c4a36a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a36a5e",
  null
  
)

export default component.exports